module.exports = __webpack_public_path__ + "static/media/27.33e1a559.png";